(function () {
// helpers
// trap focus
function $016516ffa594fd01$export$bec45a54c2e66c22(element) {
    const KEYCODE_TAB = 9;
    let focusableEls = element.querySelectorAll(`
    a[href]:not([disabled]),
    button:not([disabled]),
    textarea:not([disabled]),
    input[type="text"]:not([disabled]),
    input[type="radio"]:not([disabled]),
    input[type="checkbox"]:not([disabled]),
    select:not([disabled])
  `);
    let firstFocusableEl = focusableEls[0];
    let lastFocusableEl = focusableEls[focusableEls.length - 1];
    // set focus to first element
    firstFocusableEl.focus();
    element.addEventListener("keydown", function(e) {
        let isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB;
        if (!isTabPressed) return;
        if (e.shiftKey) {
            if (document.activeElement === firstFocusableEl) {
                lastFocusableEl.focus();
                e.preventDefault();
            }
        } else if (document.activeElement === lastFocusableEl) {
            firstFocusableEl.focus();
            e.preventDefault();
        }
    });
}


// menu.js

const $0a111e49efbd2ef4$var$hamburger = document.getElementById("hamburger");
const $0a111e49efbd2ef4$var$nav = document.getElementById("nav");
// Function to toggle the menu visibility
function $0a111e49efbd2ef4$var$toggleMenu() {
    const isOpen = $0a111e49efbd2ef4$var$hamburger.getAttribute("aria-expanded") === "true" || false;
    // Toggle aria-expanded attribute
    $0a111e49efbd2ef4$var$hamburger.setAttribute("aria-expanded", String(!isOpen));
    // Toggle nav visibility using a class
    if (!isOpen) $0a111e49efbd2ef4$var$openMenu();
    else $0a111e49efbd2ef4$var$nav.classList.remove("open");
}
// open menu
function $0a111e49efbd2ef4$var$openMenu() {
    $0a111e49efbd2ef4$var$nav.classList.add("open");
    (0, $016516ffa594fd01$export$bec45a54c2e66c22)($0a111e49efbd2ef4$var$nav);
}
// close menu
function $0a111e49efbd2ef4$var$closeMenu() {
    $0a111e49efbd2ef4$var$nav.classList.remove("open");
    $0a111e49efbd2ef4$var$hamburger.setAttribute("aria-expanded", "false");
}
// Toggle the menu on click
$0a111e49efbd2ef4$var$hamburger.addEventListener("click", $0a111e49efbd2ef4$var$toggleMenu);
// Hide nav on keyup Escape
$0a111e49efbd2ef4$var$nav.addEventListener("keyup", (e)=>{
    if (e.code === "Escape") $0a111e49efbd2ef4$var$closeMenu();
});
// Close the menu if a nav link is clicked
$0a111e49efbd2ef4$var$nav.addEventListener("click", (e)=>{
    if (e.target.tagName === "A") $0a111e49efbd2ef4$var$closeMenu();
});
document.addEventListener("click", (e)=>{
    const isHamburgerClick = e.target === $0a111e49efbd2ef4$var$hamburger || $0a111e49efbd2ef4$var$hamburger.contains(e.target);
    const isNavClick = e.target.closest("#nav") !== null;
    if (!isHamburgerClick && !isNavClick) $0a111e49efbd2ef4$var$closeMenu();
});
// Close the navigation on window resize
window.addEventListener("resize", ()=>{
    $0a111e49efbd2ef4$var$closeMenu();
});


// accordion.js
document.addEventListener("DOMContentLoaded", function() {
    var accordions = document.querySelectorAll(".accordion-button");
    accordions.forEach(function(accordion) {
        accordion.addEventListener("click", function() {
            var index = this.getAttribute("data-index");
            var targetCollapse = document.getElementById("collapse-" + index);
            // Toggle the aria-expanded attribute
            var isExpanded = this.getAttribute("aria-expanded") === "true";
            this.setAttribute("aria-expanded", !isExpanded);
            // Toggle the aria-hidden attribute
            var isHidden = targetCollapse.getAttribute("aria-hidden") === "true";
            targetCollapse.setAttribute("aria-hidden", !isHidden);
            // Toggle the class to show/hide the content
            targetCollapse.classList.toggle("show");
            // Close other accordions
            closeOtherAccordions(index);
        });
    });
    function closeOtherAccordions(currentIndex) {
        var accordions = document.querySelectorAll(".accordion-button");
        accordions.forEach(function(accordion, index) {
            if (index != currentIndex) {
                accordion.setAttribute("aria-expanded", "false");
                var targetCollapse = document.getElementById("collapse-" + index);
                targetCollapse.setAttribute("aria-hidden", "true");
                targetCollapse.classList.remove("show");
            }
        });
    }
});


// language picker
const $c13caf0966fd5fe1$var$languagePickerButton = document.getElementById("language-picker-button");
const $c13caf0966fd5fe1$var$languagePicker = document.getElementById("language-picker-list");
if ($c13caf0966fd5fe1$var$languagePickerButton && $c13caf0966fd5fe1$var$languagePicker) // toggle language picker
$c13caf0966fd5fe1$var$languagePickerButton.addEventListener("click", ()=>{
    // toggle the active class
    $c13caf0966fd5fe1$var$languagePickerButton.classList.toggle("active");
    // aria expanded
    const expanded = $c13caf0966fd5fe1$var$languagePickerButton.getAttribute("aria-expanded") === "true" || false;
    $c13caf0966fd5fe1$var$languagePickerButton.setAttribute("aria-expanded", !expanded);
    // toggle the hidden class
    $c13caf0966fd5fe1$var$languagePicker.classList.toggle("hidden");
});



})();
//# sourceMappingURL=index.js.map
